 import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import { isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, NumConv, isEnabled, isNumber } from '../modules/appLibrary';
import { styled } from '@material-ui/core/styles';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption } from '../modules/formstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const ItemBuyLedg = props => {

    const panelsdef = [];
    const formid = getformid("ItemBuyLedg", props.location.search);
    const controller = getcontroller("ItemBuyLedg", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const menuinfo = useSelector(state => state.form.menuinfo);

    const fnc = useRef();

    //データ
    const entrydataRef = useRef(null);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const ComFunc = React.forwardRef(ComFunction);


    const actionurl = {
        "update": "Forms/Update",
        "getlist": "ItemBuyLedg/GetListData",
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]




    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={true}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                usecondition={true}
           >
            </MasterBase>
        </div>
    );
};


